(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-compatibility"] && !Shopify.designMode) return;
  try {
    const STORAGE_KEY = 'starbike:selectedMoto';
  const EVENT_NAME = 'starbike:moto-change';

  class ProductCompatibility extends HTMLElement {
    connectedCallback() {
      this.textEl = this.querySelector('[data-slot="text"]');
      this.imageEl = this.querySelector('[data-slot="image"]');
      this.compatibleTpl = this.dataset.compatibleTpl || '';
      this.incompatibleTpl = this.dataset.incompatibleTpl || '';
      this.placeholderImg = this.dataset.placeholderImage || '';
      this.isUniversal = this.dataset.compatUniversal === 'true';

      const gidNode = this.querySelector('[data-compat-gids]');
      let gids = [];
      if (gidNode) {
        try {
          gids = JSON.parse(gidNode.textContent || '[]');
        } catch (_e) {
          gids = [];
        }
      }
      this.gids = new Set(gids);

      this._onChange = this._onChange.bind(this);
      document.addEventListener(EVENT_NAME, this._onChange);

      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const saved = raw ? JSON.parse(raw) : null;
        if (saved && typeof saved.gid === 'string' && saved.gid.startsWith('gid://')) {
          this._apply(saved);
        }
      } catch (_e) {
        /* noop */
      }
    }

    disconnectedCallback() {
      document.removeEventListener(EVENT_NAME, this._onChange);
    }

    _onChange(event) {
      const detail = event && event.detail;
      if (!detail || !detail.gid) {
        this.hidden = true;
        this.dataset.compatState = 'hidden';
        return;
      }
      this._apply(detail);
    }

    _apply(detail) {
      if (!detail || !detail.gid) {
        this.hidden = true;
        this.dataset.compatState = 'hidden';
        return;
      }
      const compatible = this.isUniversal || this.gids.has(detail.gid);
      const tpl = compatible ? this.compatibleTpl : this.incompatibleTpl;
      const text = tpl
        .replace(/\{\{\s*label\s*\}\}/g, detail.label || '')
        .replace(/\{\{\s*year\s*\}\}/g, detail.year || '');
      if (this.textEl) {
        this.textEl.textContent = text;
      }
      if (this.imageEl) {
        this.imageEl.src = detail.image || this.placeholderImg;
        this.imageEl.alt = detail.label || '';
      }
      this.dataset.compatState = compatible ? 'compatible' : 'incompatible';
      this.hidden = false;
    }
  }

  if (!customElements.get('product-compatibility')) {
    customElements.define('product-compatibility', ProductCompatibility);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-short-description"] && !Shopify.designMode) return;
  try {
    class ProductShortDescription extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('[data-slot="content"]');
      this.toggle = this.querySelector('[data-slot="toggle"]');
      if (!this.content || !this.toggle) return;
      this._sync();
      this._onClick = this._onClick.bind(this);
      this.toggle.addEventListener('click', this._onClick);
      this._resizeObserver = new ResizeObserver(() => this._sync());
      this._resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('click', this._onClick);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    _sync() {
      if (this.dataset.expanded === 'true') {
        this.toggle.hidden = false;
        this.dataset.truncated = 'true';
        return;
      }
      const overflows = this.content.scrollHeight - this.content.clientHeight > 1;
      this.toggle.hidden = !overflows;
      this.dataset.truncated = overflows ? 'true' : 'false';
    }

    _onClick() {
      const next = this.dataset.expanded !== 'true';
      this.dataset.expanded = next ? 'true' : 'false';
      this.toggle.setAttribute('aria-expanded', next ? 'true' : 'false');
    }
  }

  if (!customElements.get('product-short-description')) {
    customElements.define('product-short-description', ProductShortDescription);
  }
  } catch(e) { console.error(e); }
})();

})();
